import './css/index.scss';
import initFrontScript from './js/index';

initFrontScript();